import { NgModule, Component, Directive, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormBuilder, ReactiveFormsModule, FormsModule, NgControl } from '@angular/forms';

@Directive({
    selector: '[ctnmask]',
    host: {
        '(ngModelChange)': 'onInputChange($event)',
        '(keydown.backspace)': 'onInputChange($event.target.value, true)'
    }
})
export class CtnMaskDirective {

    @Input() ctnmask: boolean;
    @Input() numberOnly: boolean;
    @Input() noNumbers: boolean;
    @Output() rawChange: EventEmitter<string> = new EventEmitter<string>();
    @Input() imeimask: EventEmitter<string> = new EventEmitter<string>();

    constructor(public model: NgControl) { }

    @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent): boolean {
        const  ctnrKeys = (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true);
        const otherKeys =  (e.keyCode === 8 || e.keyCode === 9 ||
            e.keyCode === 37  || e.keyCode === 39 || e.keyCode === 46);
        const isNumber =  new RegExp('^\\d+$').test(e.key);
        const isAlphabets = new RegExp('^[A-Za-z]+$').test(e.key);

        if (ctnrKeys || otherKeys) {
            return true;
        } else if (this.ctnmask || this.numberOnly || this.imeimask) {
            return isNumber;
        } else if (this.noNumbers) {
            return isAlphabets;
        } else {
            return true;
        }
    }
    onInputChange(event, backspace) {

        if (this.ctnmask || this.numberOnly || this.imeimask) {
            // remove all mask characters (keep only numeric)
            let newVal = event.replace(/\D/g, '');
            const rawValue = newVal;
            if (backspace) {
                newVal = newVal.substring(0, newVal.length);
            }

            if (this.ctnmask) {
                // don't show dash for empty value
                if (newVal.length === 0) {
                    newVal = '';
                } else if (newVal.length <= 3) {
                    // don't show dash for empty groups at the end
                    newVal = newVal.replace(/^(\d{0,3})/, '$1');
                } else if (newVal.length <= 6) {
                    newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1.$2');
                } else {
                    newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1.$2.$3');
                }

                this.rawChange.emit(rawValue);
            }

            if(this.imeimask) {
                if(newVal.length === 0) {
                    newVal = '';
                }
            }

            // set the new value
            this.model.valueAccessor.writeValue(newVal);
        }
    }
}
